// Zostaví filter telo pre server search: { filters: [...], ...extras }

export const getFilters = (expressions: string[], extras: Record<string, any> = {}) => {
  const filters = expressions.map((expr) => {
    const [column, values] = expr.split('=');
    return {
      associated_column: column,
      predicate: '=',
      values: values.split(';').map((v) => ({ id_value: v }))
    };
  });
  return { filters, ...extras };
};
